import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import confetti from 'canvas-confetti'; // Import confetti
import parse from 'html-react-parser'; 
import GLOBAL_CONFIG from '../../config/config'; 
import appGoogleTracking from '../../modules/googletracking';
import { mainLoaderToggle, navParticipationMenu, scrollToElement } from '../../modules/helpers';
import GiftContent from '../../components/Content/GiftContent/GiftContent';
import ValidateForm from '../../modules/validate';     
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';
import TitleContent from '../../components/Content/TitleContent/TitleContent';
import ReCaptcha from 'react-google-invisible-recaptcha';         
import _LOCAL_CAPTCHA from '../../Models/Captcha';
import GiftContentFooter from '../../components/Content/GiftContent/GiftContentFooter';
import CampaignServices from '../../Services/Campaign';
import { history } from '../../App';


class ThankYou extends Component {
  //huhu
  constructor(props){
    super(props);
    this.state = {
      isMobile: false,
      name: null,
      iban: null,
      entryid: null,
      loaderSubmit: false,
      source: null,
      errorName: false,
      errorIban: false,
      formSubmitted: false,
      errorMessage: ""
    };
    this.resize = this.resize.bind(this);
    this.TriggerCaptcha = this.TriggerCaptcha.bind(this);

  }
  resize() {
    this.setState({ isMobile: window.innerWidth <= 768 });
  }

  componentWillMount() {
    window.addEventListener("resize", this.resize);
    this.resize();

    if (sessionStorage.getItem('userWin') === null) {
      //Go to particaption page
      this.props.history.push({ pathname: GLOBAL_CONFIG.Route.home });
    }
  }

  componentDidMount(){
      const { t } = this.props;
      //Active menu participation - mitmachen
      // navParticipationMenu(true);        

      //Scroll to navigation menu
      // scrollToElement();
      window.scrollTo(0, 0);
      //Remove main loader
      mainLoaderToggle('hide');

      const storedData = localStorage.getItem('participationData');
      let newState = {}

      if (storedData) {
        const parsedData = JSON.parse(storedData);
        newState = {
          firstname: parsedData.data?.Firstname || "",
          lastname: parsedData.data?.Lastname || "",
          email: parsedData.data?.Email || "", 
          entryid: parsedData.data?.ParticipationId || "" , 
          consumerid: parsedData.data?.Consumerid || ""
        }

      }

      //Virtual page
      appGoogleTracking.dataLayerPush({
          'customEvent': {
              'event': 'virtual-page',
              'virtualUri': GLOBAL_CONFIG.Route.thankyou,
              'pageTitle': t('Meta.title'),
              'ParticipantId' : window.PARTICIPATION_ID
          }
      });

      newState.winTier = localStorage.getItem('winTier');
      newState.retailer = localStorage.getItem('retailer');
      this.setState(newState);

      this.setState(newState, () => {
        if (newState.winTier === '1' || newState.winTier === '2' || newState.winTier === '3') {
        this.triggerConfetti();
        }
    });

    if (newState.winTier === '1' || newState.winTier === '2' || newState.winTier === '4') {
      sessionStorage.removeItem('userWin')
      localStorage.clear();
    }
  }
  

    // triggerConfetti() {
    //   const triangle = confetti.shapeFromPath({
    //     path: "M50 10 Q80 50 50 90 L50 10",
    //   });
  
    //   const confettiConfig = {
    //     particleCount: 60,
    //     spread: 100,
    //     colors: ['#FFD700', '#FFCC00', '#FFA500'],
    //     shapes: ['rectangle', triangle],
    //     ticks: 3000,
    //     scalar: 2.5,
    //     disableForReducedMotion: true,
    //     zIndex: 0,
    //   };
  
    //   const fireConfetti = () => {
    //     confetti({ ...confettiConfig, origin: { x: 0, y: -0.1 } }); // Left side
    //     confetti({ ...confettiConfig, origin: { x: 1, y: -0.1 } }); // Right side
    //   };
  
    //   // Trigger confetti asynchronously
    //   setTimeout(() => {
    //     requestAnimationFrame(fireConfetti);
    //   }, 100);
    // }
    triggerConfetti() {
      const script = document.createElement('script');
      const isMobile = window.innerWidth <= 768
      script.src = "https://cdn.jsdelivr.net/npm/@tsparticles/confetti@3.0.3/tsparticles.confetti.bundle.min.js";
      script.onload = () => {
        const end = Date.now() + 10 * 1000;
        const colors = ["#e0c613", "#d8ba57", "#e0b75c", "#ddb15c", "#d2a43c"];

        
  
        (function frame() {
          confetti({ particleCount: 1, angle: isMobile ? 60 : 40, spread: 40, origin: { x: 0 }, colors });
          confetti({ particleCount: 1, angle: isMobile ? 120 : 140, spread: 40, origin: { x: 1 }, colors});
  
          if (Date.now() < end && isMobile) {
              setTimeout(() => requestAnimationFrame(frame), 50);
          } else if (Date.now() < end && !isMobile) {
            requestAnimationFrame(frame)
        }
        })();
      };
      document.body.appendChild(script);
    }

    componentWillUnmount(){
        mainLoaderToggle('show');
    }

    scroll() {
      window.scrollTo({ top: 0, behavior: "smooth" });
  }

    render() { 
      
        const { t } = this.props;
        const { winTier, retailer } = this.state;

        // const winTier = "3"
        // const retailer = "Test"
        
      let image = {
        desktop: t('Page.Confirmation.bottomBanner.desktop'),
        mobile: t('Page.Confirmation.bottomBanner.mobile')
      };  

      let _captcha = _LOCAL_CAPTCHA['gluecksrad'];

        return (

          
          <div className={`content-confirmation content-confirmation__${window.PROMOTION_CAMPAIGN}`}>
            {
                this.state.loaderSubmit ?
                    <div className="simple-loader__container active">
                        <div className="simple-loader__indicator"></div>
                    </div>
                    : null
            }
            {(winTier === '1' || winTier === '2') && retailer && (
              <>
            <div className='confirmation-prize'>
              <div className='confirmation-title'>
                <picture>
                  <source srcSet={parse(t('Page.Confirmation.title.desktop.win'))} media='(min-width: 481px)'/>
                  <img src={parse(t('Page.Confirmation.title.mobile.win'))} alt='win-title'/>
                </picture>
                <p className='confirmation-subtitle'>Du hast am Gewinnspiel „Milka Glücksrad“ teilgenommen und einen {retailer} Wertgutschein in der Höhe von 500€ gewonnen!* <br/> Du wirst in den nächsten Tagen per E-Mail mit weiteren Details zu deinem Gewinn benachrichtigt.</p>
              </div>
              <div className='prize-box'>
                  <img src={parse(t('Page.Confirmation.prize.gutschein.image.path'))} />
                  <div className='prize-text'>
                    <h2 className='title'>{parse(t('Page.Confirmation.prize.gutschein.title'))}</h2>
                    <p className='description'>{parse(t('Page.Confirmation.prize.gutschein.description'))}</p>
                  </div>
              </div>
              <div className='home-page-re'>
                <div className='reminder'>
                  <img src='/resources/images/wheelspin/exclamation.svg' alt='exclamation'/>
                  <p>
                  {this.state.isMobile? parse(t('Page.Confirmation.prize.gutschein.reminderMob')) :
                  parse(t('Page.Confirmation.prize.gutschein.reminder'))}
                  </p>
                </div>
                <NavLink
                    to={GLOBAL_CONFIG.Route.home}
                    exact
                    data-event="go_to_milka"
                    data-category="Confirmation Page"
                    data-action="Go to Page"
                    data-label="MILKA_CP_OTHER"
                    onClick={(e) => {
                      appGoogleTracking.processEventCTANavLink(e);
                      this.scroll()
                      }
                    }
                  >
                  <div className="btn__container btn--primary btn--hover" style={{margin: '24px auto'}}>
                    
                    <span className="btn__text" style={{ fontSize: '16px' }}>
                      ZUR STARTSEITE
                    </span>
                  </div>
                </NavLink>
                <p style={{fontSize: '20px', textAlign:'center'}}> *Die Information über den Gewinn ist vorbehaltlich der Prüfung der Rechnung <br/> und der <NavLink to={GLOBAL_CONFIG.Route.terms} target="_blank" exact data-event="click_conditions_register_now" data-category="Take Part Page" data-action="Click on Conditions" data-label="ENG_TPP_PART" onClick={appGoogleTracking.processEventCTANavLink}>Teilnahmebedingungen</NavLink>.</p>
              </div>
              <div className='photo-feedback'>
                <p>Zeig uns ein Foto deines Gewinns oder deines Einkaufs auf Instagram, tagge <a href='https://www.instagram.com/milka_austria/' target='_blank'>@milka_austria</a> und nutze diese Hashtags: #Milka #MilkaGlücksrad #MilkamachtdasLebenzarter</p>
              </div>
              </div>
              </>
            )}
            {winTier === '3' && (
              <>
              <div className='confirmation-prize'>
              <div className='confirmation-title'>
              <picture>
                  <source srcSet={parse(t('Page.Confirmation.title.desktop.win'))} media='(min-width: 481px)'/>
                  <img src={parse(t('Page.Confirmation.title.mobile.win'))} alt='win-title'/>
                </picture>
                <p className='confirmation-subtitle'>{this.state.isMobile ? parse(t('Page.Confirmation.subTitle.einkaufMobile')): parse(t('Page.Confirmation.subTitle.einkauf'))}</p>
              </div>
              <div className='prize-box'>
                  <img style={{maxHeight:'250px'}}src={parse(t('Page.Confirmation.prize.einkauf.image.path'))} />
                  <div className='text-iban'>
                  <div className='prize-text'>
                    <h2 className='title'>{parse(t('Page.Confirmation.prize.einkauf.title'))}</h2>
                    <p className='description'>{parse(t('Page.Confirmation.prize.einkauf.description'))}</p>
                    </div>
                    <div className='iban'>
                      <form
                        id='iban-form'
                        name='iban-form'
                        method='post'
                        action='/'
                        onSubmit={this.onSubmitHandler.bind(this)} noValidate
                      >
                        <div className='form-container' id='iban-details'>
                        <p>Pflichtfelder*</p>
                        <div id="name" className="input-container">
                          <div className="form-input__container">
                              {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Label}</label> */}
                              <input className="form-input__input js-event-type-in js-event-ab"
                                  type={t("Page.Confirmation.prize.einkauf.iban.Name.Type")}
                                  name={t("Page.Confirmation.prize.einkauf.iban.Name.Id")}
                                  id={t("Page.Confirmation.prize.einkauf.iban.Name.Id")}
                                  placeholder={t("Page.Confirmation.prize.einkauf.iban.Name.Label")}
                                  data-require={t("Page.Confirmation.prize.einkauf.iban.Name.Required")}
                                  data-error-target={`#error-${t("Page.Confirmation.prize.einkauf.iban.Name.Id")}`}
                                  data-regex-pattern="^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðß ,.'-]+$"
                                  data-type="regex"
                                  data-required-message=""
                                  data-pattern-message=""
                                  data-event-fieldname="Firstname"
                                  data-event="form-click"
                                  data-category="Form Action"
                                  data-action="Firstname"
                                  data-label="Type In"
                                  ref={input => this._DETAILS_name= input}
                                  onBlur={(event) => {
                                    if (!this._DETAILS_name.value) {
                                      this.setState({ errorName: true ,formSubmitted: false})
                                      event.target.classList.add("notvalid");
                                      event.target.classList.remove("valid");
                                    } else {
                                      this.setState({ errorName: false })
                                      event.target.classList.add("valid");
                                      event.target.classList.remove("notvalid");
                                    }
                                  }}
                              />
                          </div>
                        </div>
                        <div id="iban" className="input-container">
                            <div className="form-input__container">
                                {/* <label className="form-input__label" htmlFor={t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Id} >{t("Page.Participation.Form.Sections.Details", { returnObjects: true }).Field.FirstName.Label}</label> */}
                                <input className="form-input__input js-event-type-in js-event-ab"
                                    type={t("Page.Confirmation.prize.einkauf.iban.iban.Type")}
                                    iban={t("Page.Confirmation.prize.einkauf.iban.iban.Id")}
                                    id={t("Page.Confirmation.prize.einkauf.iban.iban.Id")}
                                    placeholder={t("Page.Confirmation.prize.einkauf.iban.iban.Label")}
                                    data-require={t("Page.Confirmation.prize.einkauf.iban.iban.Required")}
                                    data-error-target={`#error-${t("Page.Confirmation.prize.einkauf.iban.iban.Id")}`}
                                    data-regex-pattern="^AT\d{18}$"
                                    data-type="regex"
                                    data-required-message=""
                                    data-pattern-message=""
                                    data-event-fieldname="Firstname"
                                    data-event="form-click"
                                    data-category="Form Action"
                                    data-action="Firstname"
                                    maxLength={20}
                                    data-label="Type In"
                                    ref={input => this._DETAILS_iban = input}
                                    onBlur={(event) => {
                                      if (!this._DETAILS_iban.value) {
                                        this.setState({ errorIban: true ,formSubmitted: false})
                                        event.target.classList.add("notvalid");
                                        event.target.classList.remove("valid");
                                      } else {
                                        this.setState({ errorIban: false })
                                        event.target.classList.add("valid");
                                        event.target.classList.remove("notvalid");
                                      }
                                    }}
                                />
                            </div>
                        </div>

                        <button type="submit" className="btn__container btn--primary btn__margin"
                            onClick={() => {
                                // this.googleTag('send_data', 'Confirmation Page', 'Click on Send Data', 'EASTER_SP_PART')
                                // this.scroll();
                            }
                            }>
                            DATEN SENDEN
                        </button>

                        <div className="form-container centered" style={{display: 'none'}}>
                          <ReCaptcha
                              ref={ref => this._CAPTCHA = ref}
                              locale={_captcha.lang}
                              sitekey={_captcha.key}
                              onResolved={this.onResolved}
                          />
                        </div>


                        </div>
                      </form>
                      {
                        this.state.errorMessage && (
                          <div>
                            <p className='error-message-iban'>
                              {this.state.errorMessage}
                            </p>
                          </div>
                        )
                      }
                  </div>
                  
                  </div>
                  
              </div>
              <div className='home-page-re'>
              <div className='reminder'>
                <img src='/resources/images/wheelspin/exclamation.svg' alt='exclamation'/>
                <p>
                {this.state.isMobile? parse(t('Page.Confirmation.prize.einkauf.reminderMob')) :
                 parse(t('Page.Confirmation.prize.einkauf.reminder'))}
                </p>
                </div>
                {/* {this.state.formSubmitted && (
                  <NavLink
                      to={GLOBAL_CONFIG.Route.home}
                      exact
                      data-event="join_now"
                      data-category="Start Page"
                      data-action="Click on Join Now"
                      data-label="EASTER_SP_PART"
                      onClick={(e) => {
                        appGoogleTracking.processEventCTANavLink(e);
                        this.scroll()
                        }
                      }
                    >
                    <div className="btn__container btn--primary btn--hover" style={{margin: '24px auto', marginBottom: '0'}}>
                      
                      <span className="btn__text" style={{ fontSize: '16px' }}>
                        ZUR STARTSEITE
                      </span>
                    </div>
                  </NavLink>
                )} */}
                <p style={{fontSize: '20px', textAlign:'center', marginTop: '24px'}}> *Die Information über den Gewinn ist vorbehaltlich der Prüfung der Rechnung <br/> und der <NavLink style={{fontFamily: 'Good Headline Pro', textDecoration: 'underline'}} to={GLOBAL_CONFIG.Route.terms} target="_blank" exact data-event="click_conditions" data-category="Confirmation Page" data-action="Click on Conditions" data-label="ENG_CP_PART" onClick={appGoogleTracking.processEventCTANavLink}>Teilnahmebedingungen</NavLink>.</p>
              </div>
              <div className='photo-feedback'>
                <p>Zeig uns ein Foto deines Gewinns oder deines Einkaufs auf Instagram, tagge <a href='https://www.instagram.com/milka_austria/' target='_blank'>@milka_austria</a> und nutze diese Hashtags: #Milka #MilkaGlücksrad #MilkamachtdasLebenzarter</p>
              </div>
              </div>
              </>
            )}

            {winTier === '4' && (
              <>
              <div className='confirmation-title'>
                <picture>
                  <source srcSet={parse(t('Page.Confirmation.title.desktop.lose'))} media='(min-width: 481px)'/>
                  <img src={parse(t('Page.Confirmation.title.mobile.lose'))} alt='lose-title'/>
                </picture>
                <p className='confirmation-subtitle'>{parse(t('Page.Confirmation.subTitle.noWin'))}</p>
              </div>
              <div className='home-page-re'>
                <NavLink
                    to={GLOBAL_CONFIG.Route.home}
                    exact
                    data-event="go_to_milka"
                    data-category="Confirmation Page"
                    data-action="Go to Page"
                    data-label="MILKA_CP_OTHER"
                    onClick={(e) => {
                      appGoogleTracking.processEventCTANavLink(e);
                      this.scroll()
                      }
                    }
                  >
                  <div className="btn__container btn--primary btn--hover" style={{margin: '24px auto'}}>
                    
                    <span className="btn__text" style={{ fontSize: '16px' }}>
                      ZUR STARTSEITE
                    </span>
                  </div>
                </NavLink>
              </div>
              </>
            )}

              <div className="content-participation-footer">
                  <GiftContentFooter btnShow={false} hrShow={false} />
              </div>
              
          </div>

        );
    }

    onSubmitHandler(e) {
      e.preventDefault();

      let validateForm = ValidateForm.validateForm('iban-form');

      if (validateForm ===  true) {
        this.TriggerCaptcha();
        this.setState({
          loaderSubmit: true,
          formSubmitted: false,
        })
      } else {
        this.setState({ formSubmitted: false }); // Allow re-submission
        const errorField = document.querySelector('.notvalid');
        if (errorField) {
            errorField.focus();
        }
        const errorFile = document.querySelector(".form-input__error.js-file-error.active");
        if (errorFile) {
            errorFile.focus();
        }
      }
    }

    TriggerCaptcha() {
      
      //Process captcha - after which form ajax will be handle
      if (this._CAPTCHA.getResponse() !== '') {
          this._CAPTCHA.reset();
      }
      this._CAPTCHA.execute();
    }

    onResolved = (token) => {
      //Process form
      this.ProcessFormData(token);
      // alert('resolve')
    }

    ProcessFormData(token, event) {
      let validateForm = ValidateForm.validateForm("iban-form")
      if (validateForm === true) {
        this.setState({
          loaderSubmit: true,
        })

        const { firstname, lastname, email, entryid, consumerid } = this.state;

  
        let data = {
          firstname,
          lastname,
          email,
          entryid,
          consumerid,
          accountname: this._DETAILS_name.value,
          iban: this._DETAILS_iban.value,
          recaptcha: token,
          source: 'website'
        }
        


  
        if (window.PROMOTION_CAMPAIGN === 'gluecksrad') {
          let _data = new FormData();
  
          for (let key in data) {
            _data.append(key, data[key]);
          }
  
          CampaignServices.Iban({
            data: _data,
          })
            .then((response) => {
  
              let {success, message, data} = response.data
  
              if (success) {
                
                this.setState({ formSubmitted: true }); 
                appGoogleTracking.dataLayerPush({
                  dataEvent: "send_data",
                  dataCategory: "Confirmation Page",
                  dataAction: "Click on Send Data",
                  dataLabel: "MILKA_CP_OTHER",
                });
            
                

                localStorage.clear();
                sessionStorage.removeItem('userWin');
                this.props.history.push({ pathname: GLOBAL_CONFIG.Route.ibanConfirm });

              } else {
  
              
                let errorMessage = ""
                // Clear input fields
                if (this._DETAILS_name) this._DETAILS_name.value = "";
                if (this._DETAILS_iban) this._DETAILS_iban.value = "";

                let errorStatus = data.Error[0];
                if (!!errorStatus) {
                  this.setState({ loaderSubmit: false });

                  switch (errorStatus) {
                    case "ALREADY_SUBMITTED":
                      errorMessage = "ALREADY_SUBMITTED";
                      break;
                    case "AN_ERROR_HAS_OCCURED":
                      errorMessage = "AN_ERROR_HAS_OCCURED";
                      break;
                    case "CAPTCHA_ERROR":
                      errorMessage = "CAPTCHA_ERROR";
                      break;
                  }
                }

                this.setState({
                  loaderSubmit: false,
                  formSubmitted: false, // Ensure form is open for input again
                  errorName: false,
                  errorIban: false,
                  errorMessage
                });
                
              }
            })
            .catch((error) => {
              let Data = error.response?.data || {};
              let errorStatus = Data?.Error?.[0] || "";
              this.ProcessError(errorStatus);
            });

        } else {
          if ( this.state.errorName|| this.state.errorIban) {
            event.target.classList.add("notvalid");
            event.target.classList.remove("valid");
          }
        }
      }
    }

    ProcessError(_ERR) {
      this.setState({
        loaderSubmit: false,
        loaderGeneralError: true,
        genericErrorMessage: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal",
      });
    }

}

export default withTranslation()(ThankYou);